import { Component, OnInit, OnDestroy } from "@angular/core";
import { Store, Action } from "@ngrx/store";
import { Angular2TokenService, SignInData } from "angular2-token";
import { Subscription } from "rxjs/Subscription";
import { Observable } from "rxjs/Observable";

import { AppState } from "@store/app-state"
import { EventsStore } from "@store/events";
import { UserStore } from "@store/user";

import { UserEffects } from "@reducers/effects/user";
import { LOGIN, LOGIN_SUCCESS, POPULATE_CURRENT_USER_CONTACT } from "@reducers/user";

import { Event } from "@models/event";
import { TicketAllocation } from "@models/ticket-allocation";
import { User } from "@models/user";
import { Contact } from "@models/contact";


@Component({
  selector: 'purchase-ticket-form',
  templateUrl: './purchase-ticket-form.pug',
})
export class PurchaseTicketFormComponent implements OnInit, OnDestroy {

  public event: Event

  public currentUserContact: Contact

  public eventsSubscription: Subscription
  public userSubscription: Subscription
  public uiState: any = { continueAsGuest: false }
  public signInData: SignInData = <SignInData>{};
  public signInError: boolean
  public signInLoading: boolean

  constructor(
    private store: Store<AppState>,
    private tokenService: Angular2TokenService,
    private userEffects: UserEffects,
  ) {}

  ngOnInit() {
    this.eventsSubscription =
      this.store.select("eventsReducer").subscribe((s: EventsStore) => {
        this.event = s.activeEvent
      })

    this.userSubscription =
      this.store.select("userReducer").subscribe((s: UserStore) => {
        this.currentUserContact = s.currentUserContact
      })
  }

  submitLogin() {
    this.signInError = false
    this.signInLoading = true

    this.tokenService.signIn(this.signInData)
      .take(1)
      .subscribe(
        (res: any) => {
          this.store.dispatch({
            type: POPULATE_CURRENT_USER_CONTACT,
            payload: JSON.parse(res._body).data.contact,
          })

          this.signInLoading = false
          this.tokenService.validateToken()
         },
        (err: any) => {
           this.signInLoading = false;
           this.signInError = true;
           return Observable.of(err)
         }
       )
  }

  clickedContinueAsGuest() {
    this.uiState.continueAsGuest = true
  }

  clickedLogout() {
    this.tokenService.signOut()
  }

  ticketAllocationsToPurchase(): TicketAllocation[] {
    return this.event.ticketAllocations.filter((ta: TicketAllocation) => {
      return ta.uiState.isPurchasing
    })
  }

  ticketAllocationsToPurchaseTotal(): number {
    return this.event.ticketAllocations.filter((ta: TicketAllocation) => {
      return ta.uiState.isPurchasing
    }).map((ta) => {
      return ta.price
    }).reduce((total, price) => {
      return total + price
    })
  }

  shouldShowLoginForm(): boolean {
    return !this.tokenService.userSignedIn() && !this.uiState.continueAsGuest
  }

  canUserPurchase() {
    return this.currentUserContact && this.currentUserContact.contactType == 0
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe()
    this.userSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/public/purchase-ticket-form.ts